import type { ReactNode } from "react";
import { useEffect } from "react";
import { StandardLayoutV2 } from "@/react/components/Layout/StandardLayoutV2";
import { useLayoutContext } from "@/react/components/SettingsApp/Layout/LayoutContext";
import { useHideTrialBanner } from "@/react/hooks/useHideTrialBanner";
import { useSettingsHeader } from "@circle-react-shared/uikit/HeaderV3/useSettingsHeader";

export interface LayoutComponentProps {
  children: ReactNode;
  hideAppBar?: boolean;
  shouldHideSidebarNestedNavBar?: boolean;
}

export const LayoutComponent = ({
  children,
  hideAppBar,
  shouldHideSidebarNestedNavBar,
  ...rest
}: LayoutComponentProps) => {
  const { config, setConfig } = useLayoutContext();
  const { isReactFlowWorkflowsRoute } = useSettingsHeader();
  useEffect(() => {
    setConfig(currentConfig => ({
      ...currentConfig,
      hideAppBar: hideAppBar ?? currentConfig.hideAppBar,
      shouldHideSidebarNestedNavBar:
        shouldHideSidebarNestedNavBar ??
        currentConfig.shouldHideSidebarNestedNavBar,
    }));
  }, [hideAppBar, shouldHideSidebarNestedNavBar, setConfig]);

  useHideTrialBanner();

  return (
    <StandardLayoutV2
      {...rest}
      disableRightSidebar={config.disableRightSidebar}
      renderLeftSidebar={config.renderLeftSidebar}
      disableSidebar={config.disableSidebar || isReactFlowWorkflowsRoute}
      hideAppBar={config.hideAppBar}
      shouldHideSidebarNestedNavBar={config.shouldHideSidebarNestedNavBar}
    >
      {children}
    </StandardLayoutV2>
  );
};
